import { LockIcon } from '@chakra-ui/icons';
import { Stack, useTheme } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button';
import Text from 'components/Text';
import { ERoute } from 'types/frontend';

export const TerminateState = () => {
  const navigate = useNavigate();
  const { borderRadius } = useTheme();

  return (
    <Stack spacing={6}>
      <Stack
        bg="whiteAlpha.200"
        borderRadius={borderRadius}
        px={6}
        py={7}
        boxShadow="0px 10px 20px rgba(0, 0, 0, 0.15)"
      >
        <Text fontWeight="semibold" opacity="default">
          Your account is terminated.
        </Text>
        <Text fontWeight="regular">
          Your subscription has ended.{' '}
          <Text as="span" opacity="default">
            Upgrade your plan
          </Text>{' '}
          to unlock full access.
        </Text>
      </Stack>
      <Button
        scheme="gradient"
        leftIcon={<LockIcon />}
        width="fit-content"
        onClick={() => navigate(ERoute.Plans)}
      >
        Unlock BIG
      </Button>
    </Stack>
  );
};
